import Vue from "vue";

const files = require.context("@/directives/", true, /^\.\/.*?\/[^_].*?\.js$/);
files.keys().forEach(item => {
    if (files(item).default) {
        Vue.use(files(item).default);
    }
});
